export default __webpack_public_path__ + "static/media/app_store.df809ae9.svg";